import { Trans } from "react-i18next";
import { appRouterPaths } from "@/services/navigation";

export const CONTACTS_SYNC_INTERVAL = 1000 * 60;

export const contactsTabs = [
  {
    id: 1,
    label: <Trans i18nKey={"contactsPage.tabs.general"} />,
    value: appRouterPaths.contacts.genInfo.split("/")[2],
  },
  {
    id: 2,
    label: <Trans i18nKey={"contactsPage.tabs.activities"} />,
    value: appRouterPaths.contacts.activities.split("/")[2],
  },
  {
    id: 3,
    label: <Trans i18nKey={"contactsPage.tabs.connections"} />,
    value: appRouterPaths.contacts.connections.split("/")[2],
  },
  {
    id: 4,
    label: <Trans i18nKey={"contactsPage.tabs.commitments"} />,
    value: appRouterPaths.contacts.commitments.split("/")[2],
  },
  {
    id: 5,
    label: <Trans i18nKey={"contactsPage.tabs.notes"} />,
    value: appRouterPaths.contacts.notes.split("/")[2],
  },
  {
    id: 6,
    label: <Trans i18nKey={"contactsPage.tabs.ideas"} />,
    value: appRouterPaths.contacts.ideas.split("/")[2],
  },
];
